import {ancestorAxis} from 'uix/views/utils'

export const xvlm = {
  //~ layout: 'Blank',
  layout: 'L131Split', // should be a vlm-specific layout: LVLM?
  acl: 'g:admin,g:qs',
  filters: [ancestorAxis],
  tabs: {
    ocr_editor: {
      parts: [{type: 'FulltextView', bare: true, autoEdit: true}],
    },
    transcription_editor: {
      parts: [{type: 'FulltextView', bare: true, autoEdit: true, transcriptionMode: true}],
    },
    ticker_editor: {
      parts: ['VlmTextTickerEditor'],
    },
    editor: {
      parts: ['VlmCodeEditor'],
    },
    veditor: {
      parts: ['VlmVisualEditor'],
    },
    deditor: {
      parts: ['VlmDescriptionEditor'],
    },
    basic_editor: {
      parts: [{type: 'VlmDescriptionEditor', hashtags: false}],
    },
    engines: {
      parts: ['VlmEngines'],
    },
    engine_reports: {
      parts: ['EngineReports'],
    },
  },
}
